export default __webpack_public_path__ + "static/media/mapfre-color.0f9861ef.svg";